import { PublicProductsResponse } from 'api/dbs';
import { Product } from 'api/dbs/models';
import { ContentProps } from 'types';
import { isProductCards } from '../isProductCards';
import { createDataTransform } from '../createDataTransform';
import { hasProductCards } from '../hasProductCards';
import { isLayoutContainer } from '../isLayoutContainer';

export const createProductCardsTransformer =
  ({ publicProducts }: { publicProducts: PublicProductsResponse }) =>
  (contents: ContentProps[]) => {
    if (!hasProductCards(contents)) {
      return contents;
    }
    const dbs = publicProducts.entries.reduce(
      (dictionary, product) => ({ ...dictionary, [product.id]: product }),
      {} as Record<Product['id'], Product>,
    );
    const transform = createDataTransform(dbs);
    return contents.map((content) => {
      if (isProductCards(content)) {
        return {
          ...content,
          componentData: {
            ...content.componentData,
            ...transform(content.componentData),
          },
        };
      }

      if (isLayoutContainer(content)) {
        return {
          ...content,
          componentData: {
            ...content.componentData,
            reference: content.componentData.reference.map((reference) => {
              if (reference._content_type_uid !== 'product_cards') {
                return reference;
              }
              return { ...reference, ...transform(reference) };
            }),
          },
        };
      }

      return content;
    });
  };

export default createProductCardsTransformer;
